import { useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import {
  NotificationMessage,
  NotificationsQueue,
} from '@/components/Notifications';
import { Endpoint } from '@/constants';
import { postData } from '@/utils/postData';

export const useSubscribeToNewsletter = () => {
  const [isSubscribed, setIsSubscribed] = useState(false);
  const [hasError, setHasError] = useState(false);

  const { isPending, mutate } = useMutation({
    mutationFn: postData(Endpoint.Subscribe),
    onSuccess: data => {
      setHasError(false);
      const { isSuccess } = data;

      const toastMessage = isSuccess
        ? 'Successfully subscribed to newsletter'
        : 'Unable to subscribe to newsletter';

      NotificationsQueue.add(
        {
          notification: (
            <NotificationMessage $isError={!isSuccess}>
              {toastMessage}
            </NotificationMessage>
          ),
        },
        { timeout: 5000 },
      );

      setIsSubscribed(isSuccess);
    },
    onError: () => {
      setHasError(true);
    },
  });

  return { hasError, isPending, isSubscribed, subscribeToNewsletter: mutate };
};
